import { useState } from "react";
import NTNavbar from "@/components/feature/NTNavbar";
import NTFooter from "@/components/feature/NTFooter";
import { Link } from "react-router-dom";

const allCases = [
  {
    id: 1,
    category: "Alimentício",
    title: "Picolezeira Automática para Grupo Alimentício Nacional",
    client: "Alimentos Premium Ltda.",
    year: "2023",
    result: "+300% produtividade",
    challenge: "O cliente precisava triplicar sua capacidade de produção de picolés sem aumentar o espaço físico da fábrica.",
    solution: "Desenvolvemos uma linha automatizada compacta com capacidade de 10.000 unidades/hora, com sistema de controle inteligente e manutenção simplificada.",
    image: "https://readdy.ai/api/search-image?query=food%20processing%20factory%20ice%20cream%20production%20line%20industrial%20automated%20machinery%20stainless%20steel%20professional%20clean%20bright&width=700&height=480&seq=ntcase_full1&orientation=landscape",
  },
  {
    id: 2,
    category: "Têxtil",
    title: "Automação Completa de Linha Têxtil",
    client: "Têxtil Horizonte S.A.",
    year: "2022",
    result: "+40% eficiência",
    challenge: "Linha de produção têxtil com equipamentos obsoletos, alto índice de paradas e baixa produtividade.",
    solution: "Retrofit completo com automação de processos, novos sistemas de controle e integração de sensores para monitoramento em tempo real.",
    image: "https://readdy.ai/api/search-image?query=textile%20factory%20automation%20modernization%20production%20line%20machinery%20upgrade%20industrial%20technology%20bright%20clean%20professional&width=700&height=480&seq=ntcase_full2&orientation=landscape",
  },
  {
    id: 3,
    category: "Metalúrgico",
    title: "Prensas CNC para Metalúrgica Nacional",
    client: "Grupo Metalúrgico Alfa",
    year: "2023",
    result: "12 máquinas entregues",
    challenge: "Necessidade de 12 prensas hidráulicas customizadas para conformação de peças automotivas com alta precisão dimensional.",
    solution: "Projeto e fabricação de 12 prensas CNC com força de 200 toneladas cada, entregues em 8 meses com treinamento completo da equipe.",
    image: "https://readdy.ai/api/search-image?query=metal%20stamping%20press%20CNC%20hydraulic%20industrial%20manufacturing%20automotive%20parts%20production%20bright%20clean%20professional&width=700&height=480&seq=ntcase_full3&orientation=landscape",
  },
  {
    id: 4,
    category: "Automobilístico",
    title: "Linha de Soldagem Robotizada",
    client: "AutoParts Brasil",
    year: "2022",
    result: "-60% tempo de ciclo",
    challenge: "Processo de soldagem manual com alta variabilidade de qualidade e baixa velocidade de produção.",
    solution: "Implementação de 4 robôs de soldagem integrados com sistema de visão computacional para controle de qualidade em tempo real.",
    image: "https://readdy.ai/api/search-image?query=robotic%20welding%20line%20automotive%20factory%20automated%20manufacturing%20bright%20clean%20professional%20industrial&width=700&height=480&seq=ntcase_full4&orientation=landscape",
  },
  {
    id: 5,
    category: "Higiene Pessoal",
    title: "Sistema de Envase para Cosméticos",
    client: "Higiene Total Ind. e Com.",
    year: "2021",
    result: "5x mais velocidade",
    challenge: "Processo de envase manual de produtos cosméticos com alto índice de desperdício e inconsistência de dosagem.",
    solution: "Linha automática de envase com dosagem volumétrica de precisão, capaz de processar 1.200 frascos por hora com desvio máximo de 0,5%.",
    image: "https://readdy.ai/api/search-image?query=automatic%20cosmetic%20filling%20packaging%20machine%20personal%20care%20products%20industrial%20production%20line%20clean%20stainless%20steel%20bright&width=700&height=480&seq=ntcase_full5&orientation=landscape",
  },
  {
    id: 6,
    category: "Automação",
    title: "Sistema SCADA para Indústria Química",
    client: "QuimicaTech S.A.",
    year: "2024",
    result: "100% rastreabilidade",
    challenge: "Falta de rastreabilidade e controle em tempo real dos processos de produção química com múltiplas variáveis críticas.",
    solution: "Implementação de sistema SCADA completo com 200 pontos de monitoramento, dashboards em tempo real e alertas automáticos.",
    image: "https://readdy.ai/api/search-image?query=SCADA%20industrial%20control%20system%20monitoring%20screens%20chemical%20plant%20automation%20technology%20bright%20professional&width=700&height=480&seq=ntcase_full6&orientation=landscape",
  },
];

const categories = ["Todos", "Alimentício", "Metalúrgico", "Têxtil", "Automobilístico", "Higiene Pessoal", "Automação"];

export default function PortfolioPage() {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [selected, setSelected] = useState<typeof allCases[0] | null>(null);

  const filtered = allCases.filter((c) => activeCategory === "Todos" || c.category === activeCategory);

  return (
    <div className="min-h-screen bg-white font-inter">
      <NTNavbar />
      <main className="pt-[88px]">

        {/* Hero */}
        <section className="relative h-[340px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=industrial%20portfolio%20cases%20success%20projects%20factory%20machinery%20professional%20bright%20clean%20modern%20manufacturing&width=1400&height=400&seq=ntporthero&orientation=landscape"
            alt="Portfólio New Tech Solution"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/80 via-[#1a1a1a]/50 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="flex items-center gap-2 mb-3">
                <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">Home</Link>
                <span className="text-white/40 text-sm">/</span>
                <span className="text-[#3FA7D6] text-sm font-semibold">Portfólio</span>
              </div>
              <h1 className="font-rajdhani font-bold text-white text-4xl md:text-5xl">Cases de Sucesso</h1>
              <p className="text-white/70 text-base mt-2">Projetos que transformaram a produção de grandes indústrias.</p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-[#1B1F5E] py-6">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {[{ num: "200+", label: "Projetos Entregues" }, { num: "10+", label: "Anos de Experiência" }, { num: "5", label: "Segmentos Industriais" }, { num: "98%", label: "Clientes Satisfeitos" }].map((s) => (
                <div key={s.label}>
                  <p className="font-rajdhani font-bold text-white text-3xl leading-none">{s.num}</p>
                  <p className="text-white/80 text-xs mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Filter */}
        <section className="bg-[#f5f5f5] py-6 border-b border-gray-200 sticky top-[88px] z-30">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${activeCategory === cat ? "bg-[#1B1F5E] text-white" : "bg-white border border-gray-200 text-[#555] hover:border-[#1B1F5E] hover:text-[#1B1F5E]"}`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Cases grid */}
        <section className="bg-white py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((c) => (
                <div
                  key={c.id}
                  className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#1B1F5E] transition-all group cursor-pointer"
                  onClick={() => setSelected(c)}
                >
                  <div className="relative w-full h-52 overflow-hidden">
                    <img src={c.image} alt={c.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-3 left-3 bg-[#1B1F5E] text-white font-bold text-xs px-2.5 py-1 rounded">{c.category}</span>
                    <span className="absolute top-3 right-3 bg-[#1a1a1a]/70 text-white text-xs px-2 py-1 rounded">{c.year}</span>
                  </div>
                  <div className="p-5">
                    <p className="text-[#999] text-xs mb-1">{c.client}</p>
                    <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-lg leading-snug mb-3">{c.title}</h3>
                    <div className="flex items-center justify-between">
                      <span className="font-bold text-[#1B1F5E] text-sm">{c.result}</span>
                      <span className="text-[#1B1F5E] text-xs font-semibold cursor-pointer hover:underline">Ver detalhes &rarr;</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#f5c518] py-5">
          <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-rajdhani font-black text-[#1a1a1a] text-xl md:text-2xl uppercase">SEU PROJETO PODE SER O PRÓXIMO CASE</p>
              <p className="text-[#1a1a1a]/70 text-sm mt-0.5">Entre em contato e veja como podemos transformar sua produção.</p>
            </div>
            <Link to="/contato" className="whitespace-nowrap bg-[#1a1a1a] hover:bg-[#333] text-white font-bold px-8 py-3 rounded-md transition-colors cursor-pointer text-sm">
              Fale Conosco
            </Link>
          </div>
        </section>

      </main>
      <NTFooter />

      {/* Case modal */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={() => setSelected(null)}>
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="relative w-full h-56 overflow-hidden rounded-t-lg">
              <img src={selected.image} alt={selected.title} className="w-full h-full object-cover object-top" />
              <button onClick={() => setSelected(null)} className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/90 rounded-full text-[#333] hover:bg-white cursor-pointer">
                <i className="ri-close-line text-lg"></i>
              </button>
              <span className="absolute top-3 left-3 bg-[#1B1F5E] text-white font-bold text-xs px-2.5 py-1 rounded">{selected.category}</span>
            </div>
            <div className="p-7">
              <p className="text-[#999] text-xs mb-1">{selected.client} · {selected.year}</p>
              <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-2xl mb-4">{selected.title}</h2>
              <div className="inline-block bg-[#1B1F5E]/10 text-[#1B1F5E] font-bold text-sm px-3 py-1.5 rounded mb-5">{selected.result}</div>
              <div className="mb-4">
                <h4 className="font-rajdhani font-bold text-[#1a1a1a] text-base mb-2">Desafio</h4>
                <p className="text-[#555] text-sm leading-relaxed">{selected.challenge}</p>
              </div>
              <div className="mb-6">
                <h4 className="font-rajdhani font-bold text-[#1a1a1a] text-base mb-2">Solução</h4>
                <p className="text-[#555] text-sm leading-relaxed">{selected.solution}</p>
              </div>
              <Link to="/contato" className="inline-flex items-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm" onClick={() => setSelected(null)}>
                Quero um projeto similar
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
